// import axios from "axios";
// import { useEffect, useState } from "react";
// import { FaChevronDown } from "react-icons/fa";
// import { Link, useLocation, useNavigate } from "react-router-dom";

// const Sidebar = ({ isMobile, onLinkClick, isCollapsed, setIsCollapsed }) => {
//   const [openDropdown, setOpenDropdown] = useState(null);
//   const [currentPage, setCurrentPage] = useState("Dashboard");
//   const [activeItem, setActiveItem] = useState("/dashboard");
//   const [hoveredItem, setHoveredItem] = useState(null);
//   const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
//   const [isHovering, setIsHovering] = useState(false);

//   const navigate = useNavigate();
//   const location = useLocation();

//   // Detect active page
//   useEffect(() => {
//     const path = location.pathname;
//     setActiveItem(path);
//     setCurrentPage(getPageNameFromPath(path));
//   }, [location]);

//   const getPageNameFromPath = (path) => {
//     const pathMap = {
//       "/dashboard": "Dashboard",
//       "/employeelist": "Employees",
//       "/attedancesummary": "Attendance Summary",
//       "/attendancelist": "Attendance Records",
//       "/today-attendance": "Today Attendance",
//       "/absent-today": "Absent Today",
//       "/leavelist": "Leaves",
//       "/payroll": "Payroll",
//       "/useractivity": "User Activity",
//       "/useraccess": "User Access",
//       "/jobpost": "Job Posts",
//       "/locationlist": "Locations",
//       "/shift": "Shifts",
//       "/addemployee": "Add Employee",
//       "/editemployee": "Edit Employee",
//       "/departmentdashboard": "Departments",
//       "/roledashboard": "Roles",
//       "/addlocation": "Add Location",
//       "/empmanagement": "Employee Management",
//       "/permissions": "Permissions",
//       "/job-applicants": "Job Applicants",
//       "/score": "Score Board",
//       "/assessment-manager": "Assessments",
//       "/documents": "Documents",
//       "/all-expensives": "Expenses"
//     };
//     return pathMap[path] || "Dashboard";
//   };

//   // Desktop Hover Expand
//   const handleMouseEnterSidebar = () => {
//     if (!isMobile) {
//       setIsHovering(true);
//       setIsCollapsed(false);
//     }
//   };

//   const handleMouseLeaveSidebar = () => {
//     if (!isMobile) {
//       setIsHovering(false);
//       if (!openDropdown) {
//         setIsCollapsed(true);
//       }
//     }
//   };

//   // Tooltip position
//   const handleMouseMove = (e, itemName) => {
//     setTooltipPosition({
//       x: e.clientX + 15,
//       y: e.clientY - 10,
//     });
//     setHoveredItem(itemName);
//   };

//   const toggleDropdown = (e, name) => {
//     e.stopPropagation();
//     e.preventDefault();
    
//     if (openDropdown !== name) {
//       if (!isMobile && isCollapsed) {
//         setIsCollapsed(false);
//       }
//       setOpenDropdown(name);
//     } else {
//       setOpenDropdown(null);
//     }
//   };

//   const handleLogout = async () => {
//     try {
//       await axios.post(
//         "https://credenhealth.onrender.com/api/admin/logout",
//         {},
//         { withCredentials: true }
//       );
//     } catch (error) {}
//     localStorage.clear();
//     navigate("/admin-login");
//   };

//   const isActive = (path) => activeItem === path;

//   const isDropdownActive = (dropdownItems) =>
//     dropdownItems?.some((item) => isActive(item.path));

//   const elements = [
//     {
//       icon: <i className="ri-dashboard-fill"></i>,
//       name: "Dashboard",
//       path: "/dashboard",
//     },
//     {
//       icon: <i className="ri-user-fill"></i>,
//       name: "Employees",
//       path: "/employeelist",
//     },
//     {
//       icon: <i className="ri-calendar-check-fill"></i>,
//       name: "Attendance",
//       dropdown: [
//         { name: "Attendance Summary", path: "/attedancesummary" },
//         { name: "Attendance Records", path: "/attendancelist" },
//         { name: "Today Attendance", path: "/today-attendance" },
//         { name: "Absent Today", path: "/absent-today" },
//       ],
//     },
//     {
//       icon: <i className="ri-calendar-close-fill"></i>,
//       name: "Leaves",
//       path: "/leavelist",
//     },
//     {
//       icon: <i className="ri-shield-keyhole-fill"></i>,
//       name: "Permissions",
//       path: "/permissions",
//     },
//     {
//       icon: <i className="ri-money-dollar-box-fill"></i>,
//       name: "Payroll",
//       path: "/payroll",
//     },
//       {
//       icon: <i className="ri-money-dollar-box-fill"></i>,
//       name: "Expensives",
//       path: "/all-expensives"
//     },


//     {
//       icon: <i className="ri-history-fill"></i>,
//       name: "User Activity",
//       path: "/useractivity",
//     },
//     {
//       icon: <i className="ri-shield-user-fill"></i>,
//       name: "User Access",
//       path: "/useraccess",
//     },
//     {
//       icon: <i className="ri-briefcase-fill"></i>,
//       name: "Recruitment",
//       dropdown: [
//         {name:  "Dashboard", path:"/recruitment-dashboard"},
//         { name: "Job Posts", path: "/jobpost" },
//         { name: "Job Applicants", path: "/job-applicants" },
//         { name: "Score Board", path: "/score" },
//         { name: "Assessments", path: "/assessment-manager" },
//         { name: "Documents", path: "/personaldocuments" },
//         { name: "Employee Journey", path: "/employee-journey" },
//       ],
//     },
//     {
//       icon: <i className="ri-map-pin-2-fill"></i>,
//       name: "Locations",
//       path: "/locationlist",
//     },
//     {
//       icon: <i className="ri-time-fill"></i>,
//       name: "Shifts",
//       path: "/shift",
//     },
//     {
//       icon: <i className="ri-logout-box-r-line"></i>,
//       name: "Logout",
//       action: handleLogout,
//     },
//   ];

//   // Handle item click to close dropdown and collapse
//   const handleItemClick = (path, action) => {
//     if (path) {
//       navigate(path);
//     }
    
//     if (action) {
//       action();
//     }
    
//     setOpenDropdown(null);
    
//     if (isMobile) {
//       setIsCollapsed(true);
//     }
    
//     if (onLinkClick) {
//       onLinkClick();
//     }
    
//     setHoveredItem(null);
//   };

//   // Handle dropdown item click
//   const handleDropdownItemClick = (path) => {
//     navigate(path);
//     setOpenDropdown(null);
    
//     if (isMobile) {
//       setIsCollapsed(true);
//     }
    
//     if (onLinkClick) {
//       onLinkClick();
//     }
//   };

//   return (
//     <>
//       {isMobile && !isCollapsed && (
//         <div
//           className="fixed inset-0 z-40 bg-[#1E3A8A] "
//           onClick={() => {
//             setIsCollapsed(true);
//             setOpenDropdown(null);
//           }}
//         />
//       )}

//       {isCollapsed && hoveredItem && !isMobile && (
//         <div
//           className="fixed z-[100] bg-[#175cd3] text-white text-sm px-3 py-2 rounded-md shadow-lg pointer-events-none"
//           style={{
//             left: `${tooltipPosition.x}px`,
//             top: `${tooltipPosition.y}px`,
//           }}
//         >
//           {hoveredItem}
//         </div>
//       )}

//       <div
//         onMouseEnter={handleMouseEnterSidebar}
//         onMouseLeave={handleMouseLeaveSidebar}
//         className={`fixed top-0 left-0 h-full bg-white border-r border-[#e4e7ec] z-50 transition-all duration-300 shadow-sm
//         ${
//           isMobile
//             ? isCollapsed
//               ? "-translate-x-full w-52"
//               : "translate-x-0 w-52"
//             : isCollapsed
//             ? "w-16"
//             : "w-52"
//         }`}
//       >
//         {/* Header */}
//         <div className="flex items-center justify-center px-3 font-bold tracking-tight border-b border-[#e4e7ec] h-14">
//           {isCollapsed && !isMobile ? (
//             <span className="text-xl text-[#175cd3]">TM</span>
//           ) : (
//             <div className="flex flex-col w-full">
//               <span className="text-xs uppercase tracking-[0.2em] font-medium text-[#667085] mb-0.5">
//                 Team Management
//               </span>
//               <div className="flex items-center gap-1.5">
//                 <div className="w-1.5 h-1.5 rounded-full bg-[#175cd3] animate-pulse"></div>
//                 <span className="text-xs font-medium truncate text-[#101828]">
//                   {currentPage}
//                 </span>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Menu */}
//         <nav className="flex-1 px-2 py-3 space-y-0.5 overflow-y-auto no-scrollbar">
//           {elements.map((item, idx) => (
//             <div key={idx}>
//               {item.dropdown ? (
//                 <>
//                   <div
//                     className={`group flex items-center justify-between px-3 py-1.5 rounded-md cursor-pointer transition-all duration-200 ${
//                       isDropdownActive(item.dropdown)
//                         ? "bg-[#175cd3] text-white shadow-[0_0_10px_rgba(23,92,211,0.2)]"
//                         : openDropdown === item.name
//                         ? "bg-[#f0f2f5]"
//                         : "hover:bg-[#f0f2f5]"
//                     }`}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       if (item.dropdown && item.dropdown.length > 0) {
//                         navigate(item.dropdown[0].path);
//                         setOpenDropdown(null);
//                         if (isMobile) {
//                           setIsCollapsed(true);
//                         }
//                         if (onLinkClick) onLinkClick();
//                       }
//                     }}
//                     onMouseEnter={(e) => isCollapsed && !isMobile && handleMouseMove(e, item.name)}
//                     onMouseMove={(e) => isCollapsed && !isMobile && handleMouseMove(e, item.name)}
//                     onMouseLeave={() => isCollapsed && !isMobile && setHoveredItem(null)}
//                   >
//                     <div className="flex items-center gap-2.5">
//                       <span className={`text-lg transition-colors duration-200 ${
//                         isDropdownActive(item.dropdown)
//                           ? "text-white"
//                           : openDropdown === item.name
//                           ? "text-[#175cd3]"
//                           : "text-[#667085] group-hover:text-[#101828]"
//                       }`}>
//                         {item.icon}
//                       </span>
//                       {!isCollapsed && (
//                         <span className={`text-[14px] font-medium leading-none ${
//                           isDropdownActive(item.dropdown) ? "text-white" : "text-[#101828]"
//                         }`}>
//                           {item.name}
//                         </span>
//                       )}
//                     </div>

//                     {!isCollapsed && (
//                       <div className="flex items-center gap-1">
//                         {isDropdownActive(item.dropdown) && (
//                           <div className="w-2 h-2 rounded-full bg-white animate-pulse"></div>
//                         )}
//                         <FaChevronDown
//                           onClick={(e) => toggleDropdown(e, item.name)}
//                           className={`text-xs transition-transform duration-300 p-0 hover:bg-[#e4e7ec] rounded cursor-pointer ${
//                             isDropdownActive(item.dropdown)
//                               ? "text-white"
//                               : openDropdown === item.name
//                               ? "text-[#667085]"
//                               : "text-[#667085]"
//                           } ${openDropdown === item.name ? "rotate-180" : ""}`}
//                           style={{
//                             width: '20px',
//                             height: '20px',
//                             minWidth: '20px',
//                             minHeight: '20px'
//                           }}
//                         />
//                       </div>
//                     )}
//                   </div>

//                   {/* DROPDOWN ITEMS */}
//                   {openDropdown === item.name && !isCollapsed && (
//                     <ul className="mt-0.5 space-y-0.5">
//                       {item.dropdown.map((sub, i) => (
//                         <li key={i}>
//                           <Link
//                             to={sub.path}
//                             onClick={() => handleDropdownItemClick(sub.path)}
//                             className={`block py-1 text-[13px] transition-colors pl-8 ${
//                               isActive(sub.path)
//                                 ? "text-[#175cd3] font-semibold"
//                                 : "text-[#667085] hover:text-[#101828]"
//                             }`}
//                           >
//                             <div className="flex items-center gap-2">
//                               {isActive(sub.path) && (
//                                 <div className="w-1.5 h-1.5 rounded-full bg-[#175cd3]"></div>
//                               )}
//                               {sub.name}
//                             </div>
//                           </Link>
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                 </>
//               ) : (
//                 <div
//                   onClick={() => handleItemClick(item.path, item.action)}
//                   onMouseEnter={(e) => isCollapsed && !isMobile && handleMouseMove(e, item.name)}
//                   onMouseMove={(e) => isCollapsed && !isMobile && handleMouseMove(e, item.name)}
//                   onMouseLeave={() => isCollapsed && !isMobile && setHoveredItem(null)}
//                   className={`group flex items-center gap-2.5 px-3 py-1.5 rounded-md cursor-pointer transition-all duration-200 ${
//                     isActive(item.path)
//                       ? "bg-[#175cd3] text-white shadow-[0_0_10px_rgba(23,92,211,0.2)]"
//                       : "hover:bg-[#f0f2f5]"
//                   }`}
//                 >
//                   <span className={`text-lg transition-colors duration-200 ${
//                     isActive(item.path)
//                       ? "text-white"
//                       : "text-[#667085] group-hover:text-[#101828]"
//                   }`}>
//                     {item.icon}
//                   </span>
//                   {!isCollapsed && (
//                     <div className="flex items-center flex-1 min-w-0 gap-2">
//                       <span className={`text-[14px] font-medium leading-none truncate ${
//                         isActive(item.path) ? "text-white" : "text-[#101828]"
//                       }`}>
//                         {item.name}
//                       </span>
//                       {isActive(item.path) && (
//                         <div className="w-2 h-2 ml-auto rounded-full bg-white animate-pulse"></div>
//                       )}
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>
//           ))}
//         </nav>

//         {/* Footer */}
//         <div className="px-4 py-3 text-[10px] text-[#667085] border-t border-[#e4e7ec] bg-[#f9fafb]">
//           {!isCollapsed ? (
//             <div className="flex flex-col gap-0.5">
//               <div className="flex items-center justify-between">
//                 <p className="font-semibold tracking-wider text-[#667085] uppercase">System v1.2</p>
//                 <div className="flex items-center gap-1 px-2 py-0.5 bg-[#175cd3]/10 rounded">
//                   <div className="w-1.5 h-1.5 rounded-full bg-[#175cd3]"></div>
//                   <span className="text-[9px] text-[#175cd3] font-medium">Active</span>
//                 </div>
//               </div>
//               <p>© 2026 Timely Health</p>
//             </div>
//           ) : (
//             <div className="text-center">
//               <div className="w-3 h-3 mx-auto mb-1 bg-[#175cd3] rounded-full animate-pulse"></div>
//               <span>©</span>
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   );
// };

// export default Sidebar;




import React, { useEffect, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FiGrid,
  FiBriefcase,
  FiUsers,
  FiStar,
  FiClipboard,
  FiFileText,
  FiCompass,
  FiCreditCard,
  FiShield,
  FiCalendar,
  FiClock,
  FiLogOut,
} from "react-icons/fi";

const Sidebar = ({ isMobile, onLinkClick, isCollapsed = false, setIsCollapsed }) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [activeItem, setActiveItem] = useState("/recruitment-dashboard");
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  // Detect active page
  useEffect(() => {
    const path = location.pathname;
    setActiveItem(path);

    elements.forEach((item) => {
      if (item.dropdown && item.dropdown.some((sub) => sub.path === path)) {
        setOpenDropdown(item.name);
      }
    });
  }, [location.pathname]);

  const toggleDropdown = (e, name) => {
    e.stopPropagation();
    e.preventDefault();
    setOpenDropdown((prev) => (prev === name ? null : name));
  };

  const handleLogout = () => {
    setShowLogoutDialog(true);
  };

  const confirmLogout = () => {
    localStorage.clear();
    setShowLogoutDialog(false);
    navigate("/client-login");
  };

  const cancelLogout = () => {
    setShowLogoutDialog(false);
  };

  const isActive = (path) => activeItem === path;

  const isDropdownActive = (dropdownItems) =>
    dropdownItems?.some((item) => isActive(item.path));

  const elements = [
    {
      icon: <FiGrid size={16} />,
      name: "Dashboard",
      path: "/recruitment-dashboard",
    },
    {
      icon: <FiBriefcase size={16} />,
      name: "Job Openings",
      dropdown: [
        { name: "All Job Posts", path: "/job-post" },
        { name: "Post New Job", path: "/post-new-job" },
        { name: "Position Status", path: "/job-positions-status" },
      ],
    },
    {
      icon: <FiUsers size={16} />,
      name: "Candidates",
      dropdown: [
        { name: "All Applicants", path: "/job-applicants" },
        { name: "Short Applicants", path: "/short-job-applicants" },
        { name: "Score Board", path: "/score" },
        { name: "Schedule Interviews", path: "/schedule-interviews" },
        { name: "Selected Hires", path: "/selected-candidates" },
        { name: "Rejected", path: "/rejected-candidates" },
      ],
    },
    {
      icon: <FiStar size={16} />,
      name: "Short Gigs",
      dropdown: [
        { name: "Post Short Job", path: "/short-jobs" },
        { name: "Posted Short Jobs", path: "/posted-short-jobs" },
      ],
    },
    {
      icon: <FiClipboard size={16} />,
      name: "Assessments",
      dropdown: [
        { name: "All Assessments", path: "/assessment-manager" },
        { name: "Create Assessment", path: "/new-assessment" },
      ],
    },
    {
      icon: <FiFileText size={16} />,
      name: "Documents",
      dropdown: [
        { name: "Personal Docs", path: "/personal-documents" },
        { name: "Offer Letters", path: "/acceptance-letter" },
        { name: "Staff Letters", path: "/employee-letters" },
        { name: "Resignations", path: "/employee-resignation" },
        { name: "Medical Certs", path: "/all-medical-certificates" },
      ],
    },
    {
      icon: <FiCompass size={16} />,
      name: "Engagement",
      path: "/employee-journey",
    },
    {
      icon: <FiCreditCard size={16} />,
      name: "Wallet & Perks",
      dropdown: [
        { name: "My Wallet", path: "/mywallet" },
        { name: "Refer & Earn", path: "/myreffral" },
        { name: "Special Offers", path: "/specialoffers" },
      ],
    },
    {
      icon: <FiShield size={16} />,
      name: "Page Access",
      path: "/page-access",
    },
    {
      icon: <FiCalendar size={16} />,
      name: "Events",
      path: "/events",
    },
    {
      icon: <FiClock size={16} />,
      name: "Attendance",
      path: "/attendancelist",
    },
  ];

  // Handle item click
  const handleItemClick = (path, action) => {
    if (path) {
      navigate(path);
    }
    if (action) {
      action();
    }
    if (isMobile && setIsCollapsed) {
      setIsCollapsed(true);
    }
    if (onLinkClick) {
      onLinkClick();
    }
  };

  // Handle dropdown item click
  const handleDropdownItemClick = (path) => {
    navigate(path);
    if (isMobile && setIsCollapsed) {
      setIsCollapsed(true);
    }
    if (onLinkClick) {
      onLinkClick();
    }
  };

  return (
    <>
      {isMobile && !isCollapsed && (
        <div
          className="fixed inset-0 z-40 bg-slate-900/60 backdrop-blur-xs"
          onClick={() => {
            if (setIsCollapsed) setIsCollapsed(true);
          }}
        />
      )}

      <aside
        className={`fixed top-0 left-0 h-screen bg-white border-r border-slate-200 z-50 transition-transform duration-200 shadow-sm flex flex-col justify-between select-none ${
          isMobile
            ? isCollapsed
              ? "-translate-x-full w-[220px]"
              : "translate-x-0 w-[220px]"
            : "w-[220px]"
        }`}
      >
        {/* Header */}
        <div className="flex items-center px-4 border-b border-slate-100 h-14 shrink-0 bg-slate-50/50">
          <div className="flex items-center gap-2.5 w-full min-w-0">
            <div className="w-8 h-8 rounded-xl bg-gradient-to-tr from-indigo-600 to-violet-600 text-white flex items-center justify-center font-black text-xs shrink-0 shadow-md shadow-indigo-600/20">
              TH
            </div>
            <div className="flex flex-col min-w-0 flex-1">
              <span className="text-xs font-black text-slate-900 tracking-tight block truncate">
                TIMELY HEALTH
              </span>
              <span className="text-[9px] uppercase tracking-widest font-black text-indigo-600 block">
                Recruiter Portal
              </span>
            </div>
          </div>
        </div>

        {/* Menu Navigation List */}
        <nav className="flex-1 px-3 py-3 space-y-1 overflow-y-auto custom-scrollbar">
          {elements.map((item, idx) => {
            const hasActiveChild = isDropdownActive(item.dropdown);
            const isSelfActive = isActive(item.path);
            const isParentOpen = openDropdown === item.name;

            return (
              <div key={idx}>
                {item.dropdown ? (
                  <>
                    <div
                      className={`group flex items-center justify-between px-3 py-2 rounded-xl cursor-pointer transition-all duration-150 ${
                        hasActiveChild
                          ? "bg-indigo-600 text-white shadow-sm shadow-indigo-600/25"
                          : isParentOpen
                          ? "bg-indigo-50 text-indigo-800"
                          : "text-slate-800 hover:text-indigo-700 hover:bg-indigo-50/60"
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (item.dropdown && item.dropdown.length > 0) {
                          handleDropdownItemClick(item.dropdown[0].path);
                        }
                      }}
                    >
                      <div className="flex items-center gap-2.5 min-w-0">
                        <span
                          className={`shrink-0 transition-colors ${
                            hasActiveChild
                              ? "text-white"
                              : isParentOpen
                              ? "text-indigo-700"
                              : "text-slate-500 group-hover:text-indigo-600"
                          }`}
                        >
                          {item.icon}
                        </span>
                        <span
                          className={`text-xs font-black leading-tight truncate ${
                            hasActiveChild
                              ? "text-white font-black"
                              : isParentOpen
                              ? "text-indigo-800 font-black"
                              : "text-slate-800 group-hover:text-indigo-700 font-black"
                          }`}
                        >
                          {item.name}
                        </span>
                      </div>

                      <div className="flex items-center gap-1 shrink-0">
                        <FaChevronDown
                          onClick={(e) => toggleDropdown(e, item.name)}
                          className={`text-[10px] transition-transform duration-200 p-0.5 rounded cursor-pointer ${
                            hasActiveChild
                              ? "text-white hover:text-white"
                              : isParentOpen
                              ? "text-indigo-700 rotate-180"
                              : "text-slate-400 group-hover:text-indigo-600"
                          }`}
                        />
                      </div>
                    </div>

                    {/* Submenu */}
                    {isParentOpen && (
                      <ul className="mt-1 mb-1 space-y-0.5 pl-3 border-l-2 border-indigo-100 ml-3.5 animate-in fade-in duration-150">
                        {item.dropdown.map((sub, i) => {
                          const isSubActive = isActive(sub.path);
                          return (
                            <li key={i}>
                              <Link
                                to={sub.path}
                                onClick={() => handleDropdownItemClick(sub.path)}
                                className={`flex items-center gap-2 py-1.5 px-2.5 rounded-lg text-xs font-black transition-colors ${
                                  isSubActive
                                    ? "bg-indigo-50 text-indigo-700 font-black"
                                    : "text-slate-700 hover:text-indigo-700 hover:bg-indigo-50/60 font-black"
                                }`}
                              >
                                {isSubActive && (
                                  <div className="w-1.5 h-1.5 rounded-full bg-indigo-600 shrink-0"></div>
                                )}
                                <span className="truncate">{sub.name}</span>
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </>
                ) : (
                  <div
                    onClick={() => handleItemClick(item.path, item.action)}
                    className={`group flex items-center gap-2.5 px-3 py-2 rounded-xl cursor-pointer transition-all duration-150 ${
                      isSelfActive
                        ? "bg-indigo-600 text-white shadow-sm shadow-indigo-600/25"
                        : "text-slate-800 hover:text-indigo-700 hover:bg-indigo-50/60"
                    }`}
                  >
                    <span
                      className={`shrink-0 transition-colors ${
                        isSelfActive
                          ? "text-white"
                          : "text-slate-500 group-hover:text-indigo-600"
                      }`}
                    >
                      {item.icon}
                    </span>
                    <span
                      className={`text-xs font-black leading-tight truncate flex-1 ${
                        isSelfActive
                          ? "text-white font-black"
                          : "text-slate-800 group-hover:text-indigo-700 font-black"
                      }`}
                    >
                      {item.name}
                    </span>
                  </div>
                )}
              </div>
            );
          })}
        </nav>

        {/* Footer */}
        <div className="p-3 border-t border-slate-100 bg-slate-50/50 shrink-0 space-y-2">
          <button
            type="button"
            onClick={handleLogout}
            className="w-full flex items-center gap-2 px-3 py-2 rounded-xl text-slate-800 hover:text-rose-600 hover:bg-rose-50 transition-colors text-xs font-black cursor-pointer"
          >
            <FiLogOut size={15} className="text-slate-400 group-hover:text-rose-600" />
            <span>Sign Out</span>
          </button>
          <div className="px-1 text-[9px] font-black text-slate-400 uppercase tracking-widest text-center">
            © 2026 Timely Health
          </div>
        </div>
      </aside>

      {/* Logout Confirmation Dialog */}
      {showLogoutDialog && (
        <div className="fixed inset-0 z-[200] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
          <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-sm border border-gray-100 animate-in fade-in zoom-in-95 duration-150 text-center space-y-4">
            <div className="w-12 h-12 rounded-full bg-rose-100 text-rose-600 flex items-center justify-center mx-auto">
              <FiLogOut size={22} />
            </div>
            <div>
              <h3 className="text-base font-bold text-gray-900">Confirm Sign Out</h3>
              <p className="text-xs text-gray-500 mt-1">
                Are you sure you want to end your current session?
              </p>
            </div>
            <div className="flex gap-2.5 pt-2">
              <button
                type="button"
                onClick={cancelLogout}
                className="flex-1 py-2.5 rounded-xl border border-gray-200 text-xs font-bold uppercase tracking-wider text-gray-600 hover:bg-gray-50 transition-colors cursor-pointer"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={confirmLogout}
                className="flex-1 py-2.5 rounded-xl bg-rose-600 hover:bg-rose-700 text-white text-xs font-bold uppercase tracking-wider transition-colors shadow-md shadow-rose-600/20 cursor-pointer"
              >
                Sign Out
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;